import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import unescape from "lodash/unescape";
import environment from "web/script/modules/environment";

const initialValues = environment.get("showPreviousButton");

export interface FeedsShowPreviousSlice {
    buttonUrl: string | null;
    isLoading: boolean;
}

let initialState: FeedsShowPreviousSlice = {
    buttonUrl: null,
    isLoading: false,
};

if (initialValues) {
    initialState.buttonUrl = unescape(initialValues.previous_url);
}
const feedsShowPrevious = createSlice({
    name: "feedsShowPrevious",
    initialState,
    reducers: {
        setButtonUrl(state, action: PayloadAction<string>): void {
            state.buttonUrl = action.payload;
        },
        setLoading(state, action: PayloadAction<boolean>): void {
            state.isLoading = action.payload;
        },
    },
});

const { actions, reducer } = feedsShowPrevious;
export const { setButtonUrl, setLoading } = actions;
export default reducer;
